export default __webpack_public_path__ + "static/media/shed1.7953f2e7.jpeg";